import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Row, Statistic, Table, Skeleton, Tag, Space, Button, Tooltip } from 'antd';
import { CloseOutlined, CheckOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {status_recibo_nomina} from '@app/constants/reciboNomina';
import {downloadRecibo} from '../../../../apis/TimbradoApi';
import { bitacoraProcesoNomina, recibosEncabezadoNomina } from '../../../../apis/ProcesoNominaApi';

const App = forwardRef(function AnioPeriodo({header, form, values, disabledForm}, ref) {
    const [info, setInfo] = useState(null);
    const [data, setData] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);
    
   
    useEffect(() => {
        (async () => {
            if(header?.num_periodo > 0){
                await refreshData();
            }
        })();
    }, [header]);

    const refreshData = async (id)=> {
        setLoading(true)
        const responseEncabezado = await recibosEncabezadoNomina(header.periodo_id, header.anio, header.num_periodo);
        if(responseEncabezado.ok){
            let data = responseEncabezado.payload;
            setData(data);
        }

        const response = await bitacoraProcesoNomina(header.periodo_id, header.anio, header.num_periodo);
        if(response.ok){
            let info = response.payload;
            setInfo(info);
        }
        setLoading(false)
    }
    
    const openDetails = async (object)=>{
        setOpenDetail(true);
        setPeriodSelected(object);
    }

    const getFile = async (object, file)=>{
        await downloadRecibo(file, header.periodo_id, header.anio, header.num_periodo, object.odoo_empleado_id)
    }

    const columns = [
        {
          title: 'Empleado',
          dataIndex: 'empleado',
          key: 'empleado',
        },
        {
          title: 'Etapa',
          dataIndex: 'estatus',
          key: 'estatus',
          render: (item, object)=> {
            if(object.estatus == status_recibo_nomina.ERROR)
                return  <>
                    <Tag color={'#f50'} key={'error'}>
                        {'Con Error'}
                    </Tag>
                    <Tooltip title={object.error}>
                        <InfoCircleOutlined />
                    </Tooltip>
                </>
    
            if(object.estatus == status_recibo_nomina.EN_PROCESO)
              return  <Tag color={'#2db7f5'} key={'en_proceso'}>
                        {'En proceso'}
                    </Tag>
  
            if(object.estatus == status_recibo_nomina.PROCESADO)
                return  <Tag color={'#87d068'} key={'PROCESADO'}>
                            {'Procesado'}
                        </Tag>
            if(object.estatus == status_recibo_nomina.CERRADO)
                return  <Tag color={'#108ee9'} key={'Cerrado'}>
                            {'Cerrado'}
                        </Tag>

            if(object.estatus == status_recibo_nomina.TIMBRADO)
                return  <Tag color={'purple'} key={'Timbrado'}>
                            {'Timbrado'}
                        </Tag>
  
            return '';
          }
        },
        {
          title: 'Estado',
          dataIndex: 'success',
          key: 'success',
          render: (item, object)=> {
            if(item){
                return <CheckOutlined style={{color:'green'}}/>
            }
            if(!item){
                return <CloseOutlined style={{color:'red'}} />
            }
            return <></>;
          }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object)=> {
              return <Space>
                {
                     object.estatus == status_recibo_nomina.TIMBRADO && <>
                        <Button type='primary' size='small' onClick={()=>{
                            getFile(object, 'xml');
                        }}>XML</Button>
                        <Button type='primary' size='small' onClick={()=>{
                            getFile(object, 'pdf');
                        }}>PDF</Button>
                    </>
                }
                {/* <Button type='primary' size='small' onClick={()=>{
                    openDetails(object);
                }}>Detalles</Button> */}
            </Space>
            }
        }
    ];

    return (
        <>
        {
            info && 
            <Row gutter={16} style={{paddingTop: 10, paddingBottom: 10}}>
                <Col span={7} offset={1}>
                    <Statistic title="Procesados" value={info.usuarios_procesados} suffix={`/ ${info.usuarios_esperados}`} />
                </Col>
                <Col span={7}>
                    <Statistic title="Correctos" value={info.usuarios_procesados_exito} suffix={`/ ${info.usuarios_esperados}`}  prefix={<CheckOutlined style={{color:'green'}}/>} />
                </Col>
                <Col span={7}>
                    <Statistic title="Incorrectos" value={info.usuarios_procesados_error} suffix={`/ ${info.usuarios_esperados}`}  prefix={<CloseOutlined style={{color:'red'}}/>}/>
                </Col>
            </Row>
        }
        {
        loading ? <Skeleton active={loading} />: <>
            {
                data.length == 0 ? <></>:
                <Table dataSource={data} columns={columns} />
            }
        </>
        }
        </>
    );
});

export default App;
